import React, { useState } from 'react'
import {
    findMember,
    uploadMemberProfilePictures,
} from '../../../../api/apiServices';
import toast, { Toaster } from 'react-hot-toast'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const ProfilePictuires = () => {
    
    const [member, setMember] = useState({});
    const [memberFound, setMemberFound] = useState(false);
    const [searchMember, setSearchMember] = useState({
        pf_number: "",
        mobile_number: "",
    });
    const [file, setFile] = useState();
    const [country, setCountry] = useState("gh");

    const handleOnChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setSearchMember((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleMobileNumber = (value, countryObj, e, formattedValue) => {
        const name = e.target.name;
        setSearchMember((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSearch = async () => {

        const memberData = {
            pf_number: searchMember.pf_number.toLocaleUpperCase(),
            mobile_number: searchMember.mobile_number
        }

        await findMember(memberData).then((res) => {
            if (res.success) {
                setMember(res.member);
                setMemberFound(true);
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
                setMemberFound(false);
                return false
            }
        });
    };
    
    const handleChange = (e) => {
        setFile(e.target.files[0]);
    };


    const handleProfilePictures = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('file', file);
        formData.set('pf_number', searchMember.pf_number);
        formData.set('mobile_number', searchMember.mobile_number);

        uploadMemberProfilePictures(formData)
            .then((res) => {
                if (res.success) {
                    toast.success(res.message, {
                        duration: 5000,
                        className: "toast-message"
                    });
                    setMember({})
                    setSearchMember({
                        pf_number:"",
                        mobile_number:"233"
                    });
                    setMemberFound(false)
                } else {
                    toast.error(res.message, {
                        duration: 5000,
                        className: "toast-message"
                    });
                    setMemberFound(false)
                }
            })
            .catch((err) => {
                toast.error(err.message, {
                    duration: 5000,
                    className: "toast-message"
                });
                setMemberFound(false)
            });
    };

    const handleCancel = () => {
        setMemberFound(false);
        setSearchMember({
            pf_number:"",
            mobile_number:"233"
        });
        return false
    };


    let content;
    content = (
        <div className="table-responsive lg table-wrapper">
            <table className="table table-bordered table-hover table-striped">
                <thead className="align">
                    <tr>
                        <th scope="col">PF Number</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">Region</th>
                        <th scope="col">Mobile Number</th>
                        <th scope="col">Email</th>

                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{member?.pf_number}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                            {member?.first_name?.toUpperCase()}&nbsp;
                            {member?.middle_name?.toUpperCase()}&nbsp;
                            {member?.last_name?.toUpperCase()}
                        </td>

                        <td style={{ whiteSpace: "nowrap" }}>
                            {member?.region?.toLocaleUpperCase()}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                            {member?.mobile_number}
                        </td>
                        <td>{member?.email}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );

    return (
        <>
            <section className="content-header">
                <h1>Member Profile Picture Management</h1>
            </section>
            <Toaster toastOptions={{ position: "top-center" }} />
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="form-group row">
                                    <div
                                        style={{ fontSize: 16, width: "15%" }}
                                        className="col-sm-2"
                                    >
                                        Search Member
                                    </div>
                                    <div className="col-sm-4">
                                        <input
                                            className="form-control"
                                            type="text"
                                            style={{
                                                width: "100%",
                                                height: 40,
                                                fontSize: 16,
                                                textTransform: "uppercase",
                                                borderRadius: 5,
                                            }}
                                            value={searchMember.pf_number}
                                            placeholder="PF Number"
                                            name="pf_number"
                                            onChange={handleOnChange}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <PhoneInput
                                            inputStyle={{
                                                fontSize: 16,
                                                color: "gray",
                                                width: "100%",
                                                height: 40,
                                            }}
                                            country={country}
                                            countryCodeEditable={false}
                                            enableSearch={true}
                                            value={searchMember.mobile_number}
                                            inputProps={{
                                                name: "mobile_number",
                                                required: true,
                                                autoFocus: false,
                                            }}
                                            onChange={(value, countryObj, e, formattedValue) =>
                                                handleMobileNumber(
                                                    value,
                                                    countryObj,
                                                    e,
                                                    formattedValue
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="col-sm-2">
                                        <button
                                            type="submit"
                                            className="btn btn-success "
                                            onClick={handleSearch}
                                        > <i className="fa fa-search"></i> Search</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {memberFound && (
                            <div className="panel-body">
                                <fieldset className="col-sm-12">
                                    <fieldset className="col-sm-6">
                                        <div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="pf_number">
                                                <abbr aria-label="required">PF Number</abbr>
                                                <strong></strong>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="pf_number"
                                                    name="pf_number"
                                                    value={member?.pf_number}
                                                    readOnly
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="name">
                                                <abbr aria-label="required">Full Name</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    readOnly
                                                    value={member?.first_name + " " + member?.middle_name + " " + member?.last_name}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="joined_date">
                                                <abbr aria-label="required">Date Registered</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="joined_date"
                                                    name="joined_date"
                                                    readOnly
                                                    value={member?.date_joined}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="region">
                                                <abbr aria-label="required">Region</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="region"
                                                    name="region"
                                                    readOnly
                                                    value={member?.region}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset className="col-sm-6">
                                        <div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="constituency">
                                                <abbr aria-label="required">Constituency</abbr>
                                                <strong></strong>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="constituency"
                                                    name="constituency"
                                                    value={member?.constituency}
                                                    readOnly
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="profession">
                                                <abbr aria-label="required">Profession</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="profession"
                                                    name="profession"
                                                    readOnly
                                                    value={member?.profession}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="mobile_number">
                                                <abbr aria-label="required">Phone Number</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="mobile_number"
                                                    name="mobile_number"
                                                    readOnly
                                                    value={member?.mobile_number}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="email">
                                                <abbr aria-label="required">Email Address</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="email"
                                                    name="email"
                                                    readOnly
                                                    value={member?.email}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                    </fieldset>
                                </fieldset>
                                <fieldset className="col-sm-12">
                                    <hr />
                                    < div className="form-group row">
                                        <label className="col-sm-2 control-label" htmlFor="profile_picture">
                                            <abbr aria-label="required"> Upload Profile Picture</abbr>
                                            <strong></strong>
                                        </label>
                                        <div className="col-sm-6">
                                            <input
                                                type="file"
                                                id="profile_picture"
                                                name="profile_picture"
                                                autoComplete='off'
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <div className="col-sm-2">
                                            <button
                                                type="submit"
                                                className="btn btn-success btn-block "
                                                onClick={handleProfilePictures}
                                            > <i className="fa fa-upload"></i> Submit</button>
                                        </div>
                                        <div className="col-sm-2">
                                            <button
                                                type="submit"
                                                className="btn btn-danger btn-block "
                                                onClick={handleCancel}
                                            > <i className="fa fa-close"></i> Cancel</button>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        )}
                    </div>
                </div>
                <div className="panel-footer"></div>
            </section >
        </>
    );
}

export default ProfilePictuires